import { schema } from 'normalizr';
import apiResourceBuilder from '../../../../common/utils/apiResourceBuilder';
import entityActionCreator from '../../../../common/utils/entityActionCreator';

export const progressApi = apiResourceBuilder('emts/federationProgress');

export const progressSchema = new schema.Entity(
  'progress',
  {},
  { idAttribute: 'stepType' }
);

export default entityActionCreator({
  schema: progressSchema,
  api: progressApi,
});



// WEBPACK FOOTER //
// ./src/App/account/actions/progress/index.js